// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3t1-g","bigColWidth":"Table_bigColWidth__1Vzzb","biggerColWidth":"Table_biggerColWidth__1xxrd","row":"Table_row__343VQ","col":"Table_col__2KH6x"};